import { getMapData } from '@/api/asterop';
import { TYPE_LAYER_GEO_MARKETING_CONCU } from '@/configuration/carteConf';

export async function getConcurrents(address, isochrone, univers, symboles) {
  const response = await getMapData(TYPE_LAYER_GEO_MARKETING_CONCU, address,
    isochrone, 5);
  return response.data.table.values.map(item => {
    return {
      id: item[0],
      nom: item[3],
      addresse: item[4],
      symbole: item[2],
      icone: symboles[item[2]],
      codeType: item[5],
      position: {
        lng: item[1].coordinates[0],
        lat: item[1].coordinates[1],
      },
    };
  });
}

export function overrideStyle(feature, styles) {
  const className = feature.getProperty('className');
  return {
    fillColor: styles[className].fillColor,
    fillOpacity: 0.75,
    strokeWeight: 0.5,
  };
}



// WEBPACK FOOTER //
// ./src/services/asterop/mapHelper.js